


















































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import ListAdressTypesSelector from '@/components/selectors/Lists/ListAdressTypesSelector.vue';
import IListAdressType from '@/store/models/IListAdressTypes';
import ListAdressTypeApi from '@/store/api/ListAdressTypesApi';
import ListCountriesSelector from '@/components/selectors/Lists/ListCountriesSelector.vue';
import IListCountries from '@/store/models/IListCountries';
import ListCountriesApi from '@/store/api/ListCountriesApi';
import IListCustomPaper from '@/store/models/IListCustomPaper';
import ListCustomPaperApi from '@/store/api/ListCustomPapersApi';
import ListCustomPapersSelector from '@/components/selectors/Lists/ListCustomPapersSelector.vue';
import IListPalletType from '@/store/models/IListPalletType';
import ListPalletTypeApi from '@/store/api/ListPalletTypesApi';
import ListPalletTypesSelector from '@/components/selectors/Lists/ListPalletTypesSelector.vue';
import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import ListPhonePrefixesApi from '../store/api/ListPhonePrefixesApi';
import ListPhonePrefixesSelector from '@/components/selectors/Lists/ListPhonePrefixesSelector.vue';
import IListCurrency from '@/store/models/IListCurrency';
import ListCurrencyApi from '../store/api/ListCurrencyApi';
import ListCurrencySelector from '@/components/selectors/Lists/ListCurrencySelector.vue';
import IListStatusInbound from '@/store/models/IListStatusInbound';
import ListStatusInboundsApi from '../store/api/ListStatusInboundsApi';
import ListStatusInboundsSelector from '@/components/selectors/Lists/ListStatusInboundSelector.vue';
import IListStatusOutbound from '@/store/models/IListStatusOutbound';
import ListStatusOutboundsApi from '../store/api/ListStatusOutboundsApi';
import ListStatusOutboundsSelector from '@/components/selectors/Lists/ListStatusOutboundSelector.vue';
import IListStatusSell from '@/store/models/IListStatusSell';
import ListStatusSellApi from '../store/api/ListStatusSellApi';
import ListStatusSellSelector from '@/components/selectors/Lists/ListStatusSellSelector.vue';
import IListStatusTransformation from '@/store/models/IListStatusTransformation';
import ListStatusTransformationApi from '../store/api/ListStatusTransformationApi';
import ListStatusTransformationSelector from '@/components/selectors/Lists/ListStatusTransformationSelector.vue';
import ListTypesInboundsSelector from '@/components/selectors/Lists/ListTypesInboundsSelector.vue';
import ListTypesOutboundsSelector from '@/components/selectors/Lists/ListTypesOutboundsSelector.vue';
import IListTypesInbounds from '../store/models/IListTypesInbounds';
import IListTypesOutbounds from '../store/models/IListTypesOutbounds';
import ListTypesInboundsApi from '../store/api/ListTypesInboundsApi';
import ListTypesOutboundsApi from '../store/api/ListTypesOutboundsApi';
import CompanyLicensesApi from '@/store/api/CompaniesLicensesApi';
import ListDocksSelector from '@/components/selectors/Lists/ListDocksSelector.vue';
import IListDock from '@/store/models/IListDock';
import ListDocksApi from '@/store/api/ListDockApi';
import IWarehouse from '@/store/models/IWarehouse';
import WarehouseApi from '@/store/api/WarehouseApi';
import ListExciseDrinkCategoriesSelector from '@/components/selectors/Lists/ListExciseDrinkCategoriesSelector.vue';
import IListExciseDrinkCategory from '@/store/models/IListExciseDrinkCategory';
import ListExciseDrinkCategoriesApi from '@/store/api/ListExciseDrinkCategoriesApi';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import { SettingsCompany } from '@/components/shared/SettingsCompany';

@Component({
    components: {
        Snackbar,
        ListAdressTypesSelector,
        ListCountriesSelector,
        ListCustomPapersSelector,
        ListPalletTypesSelector,
        ListPhonePrefixesSelector,
        ListStatusInboundsSelector,
        ListStatusOutboundsSelector,
        ListStatusSellSelector,
        ListStatusTransformationSelector,
        ListTypesInboundsSelector,
        ListTypesOutboundsSelector,
        ListCurrencySelector,
        ListDocksSelector,
        ListExciseDrinkCategoriesSelector
    }
})
export default class Settings extends Vue {
    // PersonSelector
    ListPhonePrefixesList : IListPhonePrefix[] = [];
    listPhonePrefixesApi : ListPhonePrefixesApi;
    ListCurrencyList : IListCurrency[] = [];
    listCurrencyApi : ListCurrencyApi;
    permissions : IRolePermission[] = [];
    idCompany: string = "";
    listAdressTypeApi: ListAdressTypeApi;
    ListAdressTypes: IListAdressType[] = [];
    listCountriesApi: ListCountriesApi;
    ListCountriesList: IListCountries[] = [];
    listCustomPaperApi: ListCustomPaperApi;
    ListCustomPapersList: IListCustomPaper[] = [];
    listPalletTypeApi: ListPalletTypeApi;
    ListPalletTypesList: IListPalletType[] = [];
    listStatusInboundsApi: ListStatusInboundsApi;
    ListStatusInboundsList: IListStatusInbound[] = [];
    listStatusOutboundsApi: ListStatusOutboundsApi;
    ListStatusOutboundsList: IListStatusOutbound[] = [];
    listStatusSellApi: ListStatusSellApi;
    ListStatusSellList: IListStatusSell[] = [];
    listStatusTransformationApi: ListStatusTransformationApi;
    ListStatusTransformationList: IListStatusTransformation[] = [];
    listTypesInboundsApi: ListTypesInboundsApi;
    ListTypesInboundsList: IListTypesInbounds[] = [];
    listTypesOutboundsApi: ListTypesOutboundsApi;
    ListTypesOutboundsList: IListTypesOutbounds[] = [];
    overlay : boolean = false;
    hasLicenseScanner : boolean = false;
    companyLicensesApi : CompanyLicensesApi;
    ListDocksList: IListDock[] = [];
    listDocksApi: ListDocksApi;
    WarehouseList: IWarehouse[] = [];
    warehouseApi: WarehouseApi;
    listExciseDrinkCategoriesApi: ListExciseDrinkCategoriesApi;
    ListExciseDrinkCategoriesList: IListExciseDrinkCategory[] = [];
    settingsCompanyApi: SettingsCompanyApi;
    enableExciseModule: boolean = false;
    selectedWarehouse: string = "";
    constructor() {
        super();
        this.listPhonePrefixesApi = new ListPhonePrefixesApi();
        this.listCurrencyApi = new ListCurrencyApi();
        this.listAdressTypeApi = new ListAdressTypeApi();
        this.listCountriesApi = new ListCountriesApi();
        this.listCustomPaperApi = new ListCustomPaperApi();
        this.listPalletTypeApi = new ListPalletTypeApi();
        this.listStatusInboundsApi = new ListStatusInboundsApi();
        this.listStatusOutboundsApi = new ListStatusOutboundsApi();
        this.listStatusSellApi = new ListStatusSellApi();
        this.listStatusTransformationApi = new ListStatusTransformationApi();
        this.listTypesInboundsApi = new ListTypesInboundsApi();
        this.listTypesOutboundsApi = new ListTypesOutboundsApi();
        this.companyLicensesApi = new CompanyLicensesApi();
        this.listDocksApi = new ListDocksApi();
        this.warehouseApi = new WarehouseApi();
        this.listExciseDrinkCategoriesApi = new ListExciseDrinkCategoriesApi();
        this.settingsCompanyApi = new SettingsCompanyApi("Settings");
    }

    async created() {
        await this.getPermissions();
        await this.getListPhonePrefixes();
        await this.getListCurrency();
        await this.getListAdressTypes();
        await this.getListCountries();
        await this.getListCustomPapers();
        await this.getListPalletTypes();
        await this.getListStatusInbounds();
        await this.getListStatusOutbounds();
        await this.getListStatusSell();
        await this.getListStatusTransformation();
        await this.getListTypesInbounds();
        await this.getListTypesOutbounds();
        if (this.enableExciseModule) {
            await this.getListExciseDrinkCategories();
        }
        if (this.hasLicenseScanner) {
            this.getWarehouses();
            this.getListDocks();
        }
    }
    get filteredDocks() {
        if (!this.selectedWarehouse) return [];
        return this.ListDocksList.filter(d => d.idWarehouse === this.selectedWarehouse);
    }

    async getWarehouses() {
        this.WarehouseList = await this.warehouseApi.GetWarehousesByCompanyId(this.idCompany);
    }
    async getListDocks() {
        this.ListDocksList = await this.listDocksApi.GetListDocks(this.idCompany);
    }

    async getListStatusTransformation() {
        this.ListStatusTransformationList = await this.listStatusTransformationApi.GetListStatusTransformation();
    }

    async getListStatusSell() {
        this.ListStatusSellList = await this.listStatusSellApi.GetListStatusSell();
    }

    async getListStatusOutbounds() {
        this.ListStatusOutboundsList = await this.listStatusOutboundsApi.GetListStatusOutbounds();
    }

    async getListStatusInbounds() {
        this.ListStatusInboundsList = await this.listStatusInboundsApi.GetListStatusInbounds();
    }

    async getListTypesOutbounds() {
        this.ListTypesOutboundsList = await this.listTypesOutboundsApi.GetListTypesOutbounds();
    }

    async getListTypesInbounds() {
        this.ListTypesInboundsList = await this.listTypesInboundsApi.GetListTypesInbounds();
    }
    
    async getListPalletTypes() {
        this.ListPalletTypesList = await this.listPalletTypeApi.GetListPalleTypes();
    }

    async getListCustomPapers() {
        this.ListCustomPapersList = await this.listCustomPaperApi.GetListCustomPapers();
    }

    async getListAdressTypes() {
        this.ListAdressTypes = await this.listAdressTypeApi.GetListAdressesTypes();
    }

    async getListCountries() {
        this.ListCountriesList = await this.listCountriesApi.GetListCountries();
    }

    async saveListAdressType (adresType: IListAdressType) {
        this.overlay = true;
        const id = await this.listAdressTypeApi.SaveListAdressTypes(adresType);
        if (id) {
            adresType.id = id;
            this.ListAdressTypes = [adresType].concat(this.ListAdressTypes);
            this.showMessageInfo(`The adres type ${adresType.typeName} has been successfully saved`);
        } else {
            const errors: string = this.listAdressTypeApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListAdressType (adresType: IListAdressType) {
        this.overlay = true;
        let result : boolean = await this.listAdressTypeApi.UpdateListAdressTypes(adresType);
        if (result) {
            this.showMessageInfo(`The adres type ${adresType.typeName} has been successfully edited`);
        } else {
            const errors: string = this.listAdressTypeApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListAdressType(item: IListAdressType) {
        if (!confirm('Are you sure you want to delete this adress type?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listAdressTypeApi.inUseSetting(item.id),
            'adress type'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListAdressTypeItem(item);
    }

    async deleteListAdressTypeItem(adresType: IListAdressType) {
        this.overlay = true;
        let result: boolean = await this.listAdressTypeApi.DeleteListAdressTypes(adresType.id);
        if (result) {
            const index = this.ListAdressTypes.indexOf(adresType);
            this.ListAdressTypes.splice(index, 1);
            this.showMessageInfo(`The adresType ${adresType.typeName} has been successfully deleted`);
        } else {
            const errors: string = this.listAdressTypeApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveListCountry (country: IListCountries) {
        this.overlay = true;
        const id = await this.listCountriesApi.SaveListCountries(country);
        if (id) {
            country.id = id;
            this.ListCountriesList = [country].concat(this.ListCountriesList);
            this.showMessageInfo(`The country ${country.countryName} has been successfully saved`);
        } else {
            const errors: string = this.listCountriesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListCountry (country: IListCountries) {
        this.overlay = true;
        let result : boolean = await this.listCountriesApi.UpdateListCountries(country);
        if (result) {
            this.showMessageInfo(`The country ${country.countryName} has been successfully edited`);
        } else {
            const errors: string = this.listCountriesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListCountry(item: IListCountries) {
        if (!confirm('Are you sure you want to delete this country?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listCountriesApi.inUseSetting(item.id),
            'country'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListCountryItem(item);
    }

    async deleteListCountryItem(country: IListCountries) {
        this.overlay = true;
        let result: boolean = await this.listCountriesApi.DeleteListCountries(country.id);
        if (result) {
            const index = this.ListCountriesList.indexOf(country);
            this.ListCountriesList.splice(index, 1);
            this.showMessageInfo(`The country ${country.countryName} has been successfully deleted`);
        } else {
            const errors: string = this.listCountriesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveListCustomPaper (customPaper: IListCustomPaper) {
        this.overlay = true;
        customPaper.idCompany = this.idCompany;
        const id = await this.listCustomPaperApi.SaveListCustomPaper(customPaper);
        if (id) {
            customPaper.id = id;
            this.ListCustomPapersList = [customPaper].concat(this.ListCustomPapersList);
            this.showMessageInfo(`The custom paper ${customPaper.name} has been successfully saved`);
        } else {
            const errors: string = this.listCustomPaperApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListCustomPaper (customPaper: IListCustomPaper) {
        this.overlay = true;
        let result : boolean = await this.listCustomPaperApi.UpdateListCustomPaper(customPaper);
        if (result) {
            this.showMessageInfo(`The custome paper ${customPaper.name} has been successfully edited`);
        } else {
            const errors: string = this.listCustomPaperApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListCustomPaper(item: IListCustomPaper) {
        if (!confirm('Are you sure you want to delete this custom paper?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listCustomPaperApi.inUseSetting(item.id),
            'custom paper'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListCustomPaperItem(item);
    }

    async deleteListCustomPaperItem(customPaper: IListCustomPaper) {
        this.overlay = true;
        let result: boolean = await this.listCustomPaperApi.DeleteListCustomPaper(customPaper.id);
        if (result) {
            const index = this.ListCustomPapersList.indexOf(customPaper);
            this.ListCustomPapersList.splice(index, 1);
            this.showMessageInfo(`The custom paper ${customPaper.name} has been successfully deleted`);
        } else {
            const errors: string = this.listCustomPaperApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveListPalletType (palletType: IListPalletType) {
        this.overlay = true;
        const id = await this.listPalletTypeApi.SaveListPalletType(palletType);
        if (id) {
            palletType.id = id;
            this.ListPalletTypesList = [palletType].concat(this.ListPalletTypesList);
            this.showMessageInfo(`The pallet type ${palletType.name} has been successfully saved`);
        } else {
            const errors: string = this.listPalletTypeApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListPalletType (palletType: IListPalletType) {
        this.overlay = true;
        let result : boolean = await this.listPalletTypeApi.UpdateListPalletType(palletType);
        if (result) {
            this.showMessageInfo(`The status inbound ${palletType.name} has been successfully edited`);
        } else {
            const errors: string = this.listPalletTypeApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListPalletType(item: IListPalletType) {
        if (!confirm('Are you sure you want to delete this pallet type?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listPalletTypeApi.inUseSetting(item.id),
            'pallet type'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListPalletTypeItem(item);
    }

    async deleteListPalletTypeItem(palletType: IListPalletType) {
        this.overlay = true;
        let result: boolean = await this.listPalletTypeApi.DeleteListPalletType(palletType.id);
        if (result) {
            const index = this.ListPalletTypesList.indexOf(palletType);
            this.ListPalletTypesList.splice(index, 1);
            this.showMessageInfo(`The pallet type ${palletType.name} has been successfully deleted`);
        } else {
            const errors: string = this.listPalletTypeApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListStatusInbound(item: IListStatusInbound) {
        if (!confirm('Are you sure you want to delete this status inbound?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listStatusInboundsApi.inUseSetting(item.id),
            'inbound status'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListStatusInboundItem(item);
    }

    async deleteListStatusInboundItem(statusInbound: IListStatusInbound) {
        this.overlay = true;
        let result: boolean = await this.listStatusInboundsApi.DeleteListStatusInbound(statusInbound.id);
        if (result) {
            const index = this.ListStatusInboundsList.indexOf(statusInbound);
            this.ListStatusInboundsList.splice(index, 1);
            this.showMessageInfo(`The status inbound ${statusInbound.name} has been successfully deleted`);
        } else {
            const errors: string = this.listStatusInboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveListStatusInbound (statusInbound: IListStatusInbound) {
        this.overlay = true;
        const id = await this.listStatusInboundsApi.SaveListStatusInbound(statusInbound);
        if (id) {
            statusInbound.id = id;
            this.ListStatusInboundsList = [statusInbound].concat(this.ListStatusInboundsList);
            this.showMessageInfo(`The status inbound ${statusInbound.name} has been successfully saved`);
        } else {
            const errors: string = this.listStatusInboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListStatusInbound (statusInbound: IListStatusInbound) {
        this.overlay = true;
        let result : boolean = await this.listStatusInboundsApi.UpdateListStatusInbound(statusInbound);
        if (result) {
            this.showMessageInfo(`The status inbound ${statusInbound.name} has been successfully edited`);
        } else {
            const errors: string = this.listStatusInboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListStatusOutbound(item: IListStatusOutbound) {
        if (!confirm('Are you sure you want to delete this status outbound?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listStatusOutboundsApi.inUseSetting(item.id),
            'outbound status'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListStatusOutboundItem(item);
    }

    async deleteListStatusOutboundItem(statusOutbound: IListStatusOutbound) {
        this.overlay = true;
        let result: boolean = await this.listStatusOutboundsApi.DeleteListStatusOutbound(statusOutbound.id);
        if (result) {
            const index = this.ListStatusOutboundsList.indexOf(statusOutbound);
            this.ListStatusOutboundsList.splice(index, 1);
            this.showMessageInfo(`The status outbound ${statusOutbound.name} has been successfully deleted`);
        } else {
            const errors: string = this.listStatusOutboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveListStatusOutbound (statusOutbound: IListStatusOutbound) {
        this.overlay = true;
        const id = await this.listStatusOutboundsApi.SaveListStatusOutbound(statusOutbound);
        if (id) {
            statusOutbound.id = id;
            this.ListStatusOutboundsList = [statusOutbound].concat(this.ListStatusOutboundsList);
            this.showMessageInfo(`The status outbound ${statusOutbound.name} has been successfully saved`);
        } else {
            const errors: string = this.listStatusOutboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListStatusOutbound (statusOutbound: IListStatusOutbound) {
        this.overlay = true;
        let result : boolean = await this.listStatusOutboundsApi.UpdateListStatusOutbound(statusOutbound);
        if (result) {
            this.showMessageInfo(`The status outbound ${statusOutbound.name} has been successfully edited`);
        } else {
            const errors: string = this.listStatusOutboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }
    
    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Settings"));
        const settingsCompany = SettingsCompany.Settings.EnableAGPExciseModule;
        const setting = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);
        if (setting.length > 0) {
            this.enableExciseModule = true;
        }
        let licencesForms = await this.companyLicensesApi.GetLicenceByIdCompany(this.idCompany);
  
        this.hasLicenseScanner = !licencesForms.some(license => license.formName.toLocaleLowerCase() === "scanner");
    }

    async getListExciseDrinkCategories() {
        this.ListExciseDrinkCategoriesList = await this.listExciseDrinkCategoriesApi.GetListExciseDrinkCategories();
    }

    async saveListExciseDrinkCategory(listExciseDrinkCategory: IListExciseDrinkCategory) {
        this.overlay = true;
        const id = await this.listExciseDrinkCategoriesApi.SaveListExciseDrinkCategory(listExciseDrinkCategory);
        if (id) {
            listExciseDrinkCategory.id = id;
            this.ListExciseDrinkCategoriesList = [listExciseDrinkCategory, ...this.ListExciseDrinkCategoriesList];
            this.showMessageInfo(`The excise tariff category ${listExciseDrinkCategory.name} has been successfully saved`);
        } else {
            const errors: string = this.listExciseDrinkCategoriesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListExciseDrinkCategory(listExciseDrinkCategory: IListExciseDrinkCategory) {
        this.overlay = true;
        let result : boolean = await this.listExciseDrinkCategoriesApi.UpdateListExciseDrinkCategory(listExciseDrinkCategory);
        if (result) {
            this.showMessageInfo(`The excise tariff category ${listExciseDrinkCategory.name} has been successfully edited`);
        } else {
            const errors: string = this.listExciseDrinkCategoriesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListExciseDrinkCategory(item: IListExciseDrinkCategory) {
        if (!confirm('Are you sure you want to delete this excise tariff category?')) {
            return;
        }

        await this.deleteListExciseDrinkCategoryItem(item);
    }

    async deleteListExciseDrinkCategoryItem(listExciseDrinkCategory: IListExciseDrinkCategory) {
        this.overlay = true;
        let result: boolean = await this.listExciseDrinkCategoriesApi.DeleteListExciseDrinkCategory(listExciseDrinkCategory.id);
        if (result) {
            const index = this.ListExciseDrinkCategoriesList.indexOf(listExciseDrinkCategory);
            this.ListExciseDrinkCategoriesList.splice(index, 1);
            this.showMessageInfo(`The excise tariff category ${listExciseDrinkCategory.name} has been successfully deleted`);
        } else {
            const errors: string = this.listExciseDrinkCategoriesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async getListPhonePrefixes() {
        this.ListPhonePrefixesList = await this.listPhonePrefixesApi.GetListPhonePrefixes();
    }
    
    async saveListPhonePrefix (phonePrefix: IListPhonePrefix) {
        this.overlay = true;
        const id = await this.listPhonePrefixesApi.SaveListPhonePrefix(phonePrefix);
        if (id) {
            phonePrefix.id = id;
            this.ListPhonePrefixesList = [phonePrefix].concat(this.ListPhonePrefixesList);
            this.showMessageInfo(`The phone prefix ${phonePrefix.country} has been successfully saved`);
        } else {
            const errors: string = this.listPhonePrefixesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListPhonePrefix (phonePrefix: IListPhonePrefix) {
        this.overlay = true;
        let result : boolean = await this.listPhonePrefixesApi.UpdateListPhonePrefix(phonePrefix);
        if (result) {
            this.showMessageInfo(`The phone prefix ${phonePrefix.country} has been successfully edited`);
        } else {
            const errors: string = this.listPhonePrefixesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListPhonePrefix(item: IListPhonePrefix) {
        if (!confirm('Are you sure you want to delete this phone prefix?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listPhonePrefixesApi.inUseSetting(item.id),
            'phone prefix'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListPhonePrefixItem(item);
    }

    async deleteListPhonePrefixItem(phonePrefix: IListPhonePrefix) {
        this.overlay = true;
        let result: boolean = await this.listPhonePrefixesApi.DeleteListPhonePrefix(phonePrefix.id);
        if (result) {
            const index = this.ListPhonePrefixesList.indexOf(phonePrefix);
            this.ListPhonePrefixesList.splice(index, 1);
            this.showMessageInfo(`The phone prefix ${phonePrefix.country} has been successfully deleted`);
        } else {
            const errors: string = this.listStatusOutboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async getListCurrency() {
        this.ListCurrencyList = await this.listCurrencyApi.GetListCurrencies();
    }
    
    async saveListCurrency (currency: IListCurrency) {
        this.overlay = true;
        currency.idCompany = this.idCompany;
        const id = await this.listCurrencyApi.SaveListCurrency(currency);
        if (id) {
            currency.id = id;
            this.ListCurrencyList = [currency].concat(this.ListCurrencyList);
            this.showMessageInfo(`The currency ${currency.name} has been successfully saved`);
        } else {
            const errors: string = this.listCurrencyApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListCurrency (currency: IListCurrency) {
        this.overlay = true;
        let result : boolean = await this.listCurrencyApi.UpdateListCurrency(currency);
        if (result) {
            this.showMessageInfo(`The currency ${currency.name} has been successfully edited`);
        } else {
            const errors: string = this.listCurrencyApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListCurrency(item: IListCurrency) {
        if (!confirm('Are you sure you want to delete this currency?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listCurrencyApi.inUseSetting(item.id),
            'currency'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListCurrencyItem(item);
    }

    async deleteListCurrencyItem(currency: IListCurrency) {
        this.overlay = true;
        let result: boolean = await this.listCurrencyApi.DeleteListCurrency(currency.id);
        if (result) {
            const index = this.ListCurrencyList.indexOf(currency);
            this.ListCurrencyList.splice(index, 1);
            this.showMessageInfo(`The currency ${currency.name} has been successfully deleted`);
        } else {
            const errors: string = this.listStatusOutboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListStatusSell(item: IListStatusSell) {
        if (!confirm('Are you sure you want to delete this status sell?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listStatusSellApi.inUseSetting(item.id),
            'sell status'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListStatusSellItem(item);
    }

    async deleteListStatusSellItem(statusSell: IListStatusSell) {
        this.overlay = true;
        let result: boolean = await this.listStatusSellApi.DeleteListStatusSell(statusSell.id);
        if (result) {
            const index = this.ListStatusSellList.indexOf(statusSell);
            this.ListStatusSellList.splice(index, 1);
            this.showMessageInfo(`The status sell ${statusSell.name} has been successfully deleted`);
        } else {
            const errors: string = this.listStatusSellApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveListStatusSell (statusSell: IListStatusSell) {
        this.overlay = true;
        const id = await this.listStatusSellApi.SaveListStatusSell(statusSell);
        if (id) {
            statusSell.id = id;
            statusSell.idCompany = this.idCompany;
            this.ListStatusSellList = [statusSell].concat(this.ListStatusSellList);
            this.showMessageInfo(`The status sell ${statusSell.name} has been successfully saved`);
        } else {
            const errors: string = this.listStatusSellApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListStatusSell (statusSell: IListStatusSell) {
        this.overlay = true;
        let result : boolean = await this.listStatusSellApi.UpdateListStatusSell(statusSell);
        if (result) {
            this.showMessageInfo(`The status sell ${statusSell.name} has been successfully edited`);
        } else {
            const errors: string = this.listStatusSellApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListStatusTransformation(item: IListStatusTransformation) {
        if (!confirm('Are you sure you want to delete this status transformation?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listStatusTransformationApi.inUseSetting(item.id),
            'transformation status'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListStatusTransformationItem(item);
    }

    async deleteListStatusTransformationItem(statusTransformation: IListStatusTransformation) {
        this.overlay = true;
        let result: boolean = await this.listStatusTransformationApi.DeleteListStatusTransformation(statusTransformation.id);
        if (result) {
            const index = this.ListStatusTransformationList.indexOf(statusTransformation);
            this.ListStatusTransformationList.splice(index, 1);
            this.showMessageInfo(`The status transformation ${statusTransformation.name} has been successfully deleted`);
        } else {
            const errors: string = this.listStatusSellApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveListStatusTransformation (statusTransformation: IListStatusTransformation) {
        this.overlay = true;
        statusTransformation.idCompany = this.idCompany;
        const id = await this.listStatusTransformationApi.SaveListStatusTransformation(statusTransformation);
        if (id) {
            statusTransformation.id = id;
            this.ListStatusTransformationList = [statusTransformation].concat(this.ListStatusTransformationList);
            this.showMessageInfo(`The status transformation ${statusTransformation.name} has been successfully saved`);
        } else {
            const errors: string = this.listStatusTransformationApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListStatusTransformation (statusTransformation: IListStatusTransformation) {
        this.overlay = true;
        let result : boolean = await this.listStatusTransformationApi.UpdateListStatusTransformation(statusTransformation);
        if (result) {
            this.showMessageInfo(`The status transformation ${statusTransformation.name} has been successfully edited`);
        } else {
            const errors: string = this.listStatusTransformationApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListTypesInbound(item: IListTypesInbounds) {
        if (!confirm('Are you sure you want to delete this Types inbound?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listTypesInboundsApi.inUseSetting(item.id),
            'inbound type'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListTypesInboundItem(item);
    }

    async deleteListTypesInboundItem(TypesInbound: IListTypesInbounds) {
        this.overlay = true;
        let result: boolean = await this.listTypesInboundsApi.DeleteListTypesInbounds(TypesInbound.id);
        if (result) {
            const index = this.ListTypesInboundsList.indexOf(TypesInbound);
            this.ListTypesInboundsList.splice(index, 1);
            this.showMessageInfo(`The Types inbound ${TypesInbound.name} has been successfully deleted`);
        } else {
            const errors: string = this.listTypesInboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveListTypesInbound (TypesInbound: IListTypesInbounds) {
        this.overlay = true;
        const id = await this.listTypesInboundsApi.SaveListTypesInbounds(TypesInbound);
        if (id) {
            TypesInbound.id = id;
            this.ListTypesInboundsList = [TypesInbound, ...this.ListTypesInboundsList];
            this.showMessageInfo(`The Types inbound ${TypesInbound.name} has been successfully saved`);
        } else {
            const errors: string = this.listTypesInboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListTypesInbound (TypesInbound: IListTypesInbounds) {
        this.overlay = true;
        let result : boolean = await this.listTypesInboundsApi.UpdateListTypesInbounds(TypesInbound);
        if (result) {
            this.showMessageInfo(`The Types inbound ${TypesInbound.name} has been successfully edited`);
        } else {
            const errors: string = this.listTypesInboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListTypesOutbound(item: IListTypesOutbounds) {
        if (!confirm('Are you sure you want to delete this Types outbound?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listTypesOutboundsApi.inUseSetting(item.id),
            'outbound type'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListTypesOutboundItem(item);
    }

    async deleteListTypesOutboundItem(TypesOutbound: IListTypesOutbounds) {
        this.overlay = true;
        let result: boolean = await this.listTypesOutboundsApi.DeleteListTypesOutbounds(TypesOutbound.id);
        if (result) {
            const index = this.ListTypesOutboundsList.indexOf(TypesOutbound);
            this.ListTypesOutboundsList.splice(index, 1);
            this.showMessageInfo(`The Types outbound ${TypesOutbound.name} has been successfully deleted`);
        } else {
            const errors: string = this.listTypesOutboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveListTypesOutbound (TypesOutbound: IListTypesOutbounds) {
        this.overlay = true;
        const id = await this.listTypesOutboundsApi.SaveListTypesOutbounds(TypesOutbound);
        if (id) {
            TypesOutbound.id = id;
            this.ListTypesOutboundsList = [TypesOutbound, ...this.ListTypesOutboundsList];
            this.showMessageInfo(`The Types outbound ${TypesOutbound.name} has been successfully saved`);
        } else {
            const errors: string = this.listTypesOutboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListTypesOutbound (TypesOutbound: IListTypesOutbounds) {
        this.overlay = true;
        let result : boolean = await this.listTypesOutboundsApi.UpdateListTypesOutbounds(TypesOutbound);
        if (result) {
            this.showMessageInfo(`The Types outbound ${TypesOutbound.name} has been successfully edited`);
        } else {
            const errors: string = this.listTypesOutboundsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    get selectedWarehouseName(): string {
        const wh = this.WarehouseList.find(w => w.id === this.selectedWarehouse);
        return wh ? wh.name : "";
    }

    async saveListDock(dock: IListDock) {
        this.overlay = true;
        dock.idCompany = this.idCompany;
        
        if (this.selectedWarehouse) {
            dock.idWarehouse = this.selectedWarehouse;
        }
        const id = await this.listDocksApi.SaveListDock(dock);
        if (id) {
            dock.id = id;
            this.ListDocksList = [dock].concat(this.ListDocksList);
            this.showMessageInfo(`The dock ${dock.name} has been successfully saved for warehouse ${this.selectedWarehouseName}`);
        } else {
            const errors: string = this.listDocksApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editListDock(dock: IListDock) {
        this.overlay = true;
        dock.idCompany = this.idCompany;
        if (this.selectedWarehouse) {
            dock.idWarehouse = this.selectedWarehouse;
        }

        let result: boolean = await this.listDocksApi.UpdateListDock(dock);
        if (result) {
            this.showMessageInfo(`The dock ${dock.name} has been successfully edited in warehouse ${this.selectedWarehouseName}`);
        } else {
            const errors: string = this.listDocksApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async deleteListDock(item: IListDock) {
        if (!confirm('Are you sure you want to delete this dock?')) {
            return;
        }

        this.overlay = true;
        const canDelete = await this.validateSettingNotInUse(
            () => this.listDocksApi.inUseSetting(item.id),
            'dock'
        );
        this.overlay = false;

        if (!canDelete) {
            return;
        }

        await this.deleteListDockItem(item);
    }

    async deleteListDockItem(dock: IListDock) {
        this.overlay = true;
        let result: boolean = await this.listDocksApi.DeleteListDock(dock.id);
        if (result) {
            const index = this.ListDocksList.indexOf(dock);
            this.ListDocksList.splice(index, 1);
            this.showMessageInfo(`The dock ${dock.name} has been successfully deleted`);
        } else {
            const errors: string = this.listDocksApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async validateSettingNotInUse(
        inUseAction: () => Promise<boolean>,
        settingLabel: string
    ): Promise<boolean> {
        try {
            const isInUse = await inUseAction();

            if (isInUse) {
                this.showMessageWarning(`The ${settingLabel} is in use and cannot be deleted.`);
                return false;
            }

            return true;
        } catch (error) {
            this.showMessageError(`Could not validate whether the ${settingLabel} is in use.`);
            return false;
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
